import React, { Component } from "react";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { Typography, Dialog, Grid } from "@material-ui/core/";

//Components import
import DashboardExclutions from "./Exclutions/DashboardExclutions";
import DashboardSKULimits from "./SKULimits/DashboardSKULimits";
import fetchAPI from "../../../../components/utils/fetchAPI";

//component tabs
import { makeStyles } from "@material-ui/styles";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import Box from "@material-ui/core/Box";
import Paper from "@material-ui/core/Paper";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import PropTypes from "prop-types";
import PhoneIcon from "@material-ui/icons/Phone";

// Import CSS Styles
import "./DashboardProducts.scss";

import runtimeEnv from "@mars/heroku-js-runtime-env";
import { DialogContent } from "@mui/material";
import { green } from "@material-ui/core/colors";
import DialogLoaderHoneyLoad from "../../Components/DialogLoaderHoneyLoad/DialogLoaderHoneyLoad";

import { iterator } from "../../../../components/utils/helpers";

const env = runtimeEnv();

const useStyles = makeStyles({
  root: {
    flexGrow: 1,
  },
  title: {
    marginBottom: "30px",
  },
  header: {
    marginBottom: "20px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  card: {
    marginBottom: "20px",
  },
  content: {
    paddingTop: 0,
    textAlign: "left",
    overflowX: "auto",
    "& table": {
      marginBottom: 0,
    },
  },
  cardHeader: {
    padding: "30px",
    backgroundColor: green,
  },
});

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
  {
    console.log("index", index);
  }
}

export default class DashboardProducts extends Component {
  state = {
    value: 0,
    setValue: 0,
    dataI: 0,
    switch: false,
    respuesta: [],
    selectedCountry: "",
    selectedCountryCode: "",
    selectedCountryPrev: "",
    selectedCountryCodePrev: "",
    tabs: ["+ NUEVO GRUPO" /* , "SKU LIMITS" */],
    stateTabsView: false,
    selectedTab: "EXCLUSIONES",
    products: [],
    hoursModificate: "",
    selectedProduct: " - ",
    valueProduct: "",
    valueSku: "",
    clients: null,
    clasification: null,
    tabView: null,
    availableCountries: [],
    elementsZone: [],
    /** Dialog Loader */
    dialogLoader: {
      show: true,
      message: "Procesando",
    },
    /** Reestrcuture cards */
    cardZone: {
      title: this.props.countriesCode === "mdcolombia" ? "Zona" : "UEN" ,
      service:
        env.REACT_APP_SERVICES_GET_ORGANIZATIONS +
        "/" +
        this.props.countriesCode,
      rules: [],
      id: this.props.countriesCode === "mdcolombia" ? "zone" : "org",
    },
    cardOffices: {
      title:
        this.props.countriesCode === "mdcolombia"
          ? "Gerencia de Ventas"
          : "Direccion Regional de Ventas",
      service:
        env.REACT_APP_SERVICES_GET_OFFICES + "/" + this.props.countriesCode,
      rules: [],
      id: "offices",
    },
    cardDistribution: {
      title: "Centro de Distribución",
      service:
        env.REACT_APP_SERVICES_GET_DISTRIBUTION +
        "/" +
        this.props.countriesCode,
      rules: [],
      id: this.props.countriesCode === "mdcolombia" ? "distribution" : "sales_orgs",
    },
    cardChannel: {
      title: "Canal",
      service:
        env.REACT_APP_SERVICES_GET_CHANNEL + "/" + this.props.countriesCode,
      rules: [],
      id: "channel",
    },
    cardSubChannel: {
      title: "Subcanal",
      service:
        env.REACT_APP_SERVICES_GET_SUBCHANNEL + "/" + this.props.countriesCode,
      rules: [],
      id: "subchannel",
    },
    cardBusinessType: {
      title:
        this.props.countriesCode === "mdcolombia"
          ? "Tipo de negocio"
          : "Canal - Segmentos",
      service:
        this.props.countriesCode === "mdcolombia"
          ? `v1/channels-structure/business-type/${this.props.countriesCode}`
          : `v1/channels-structure/segment/${this.props.countriesCode}`,
      rules: [],
      id: "business-type",
    },
    cardState: {
      title: "Estado/Departamento",
      service:
        env.REACT_APP_SERVICES_GET_MUNICIPALITY +
        "/" +
        this.props.countriesCode,
      rules: [],
      id: "state",
    },
    cardCity: {
      title: "Ciudad",
      service:
        env.REACT_APP_SERVICES_GET_REGION + "/" + this.props.countriesCode,
      rules: [],
      id: "city",
    },
    cardClientsExceptions: {
      title: "Clientes con excepción",
      service: env.REACT_APP_SERVICES_INFINITI_CLIENTS,
      id: "clients_exception",
      properties: { id: ["cust_no", "name"] },
      rules: [],
    },
    cardClientsExclusions: {
      title: "Clientes con exclusión",
      service: env.REACT_APP_SERVICES_INFINITI_CLIENTS,
      id: "clients",
      properties: { id: ["cust_no", "name"] },
      rules: [],
    },
    /** Reestrcuture cards */
    cardZoneMX: {
      title: "DRV",
      service:
        env.REACT_APP_SERVICES_GET_ZONE +
        "/" +
        this.props.countriesCode,
      rules: [],
      id: "zone",
    },
    cardDistributionFiltered: {},
    cardClients: {
      title: "Clientes",
      id: "clients",
    },
    cardSegmento: {
      title: "Segmento",
      id: "clasifications",
    },
    cardDRV: {
      title: "Direccion Regional de Ventas",
      id: "dvr",
    },
    buttonUpdateDisabled: true,
    rules: {},
    selectedDateStart: null,
    selectedDateEnd: null,
    dialogAlert: false,
    loadedCards: 0,
    dataExclusionsSegments: [],
    dataExclusionsDRVZone: [],
    dataExclusionsDRVSalesOrg: [],
    dataExclusionsDRVOrg: [],
    dataRules: [],
    changeRules: false,
    openModalExclu: false,
    selectedGroupData:{}
  };

  clientsExclusion = [];
  clientsException = [];

  componentDidMount = async () => {
    //this.fetchCountries();
    this.setState({
      selectedCountryCode: this.props.countriesCode,
    });
    // await this.fetchExclutions({ country: this.props.countriesCode });
    await this.fetchProducts({ country: this.props.countriesCode });
  };

  emptyExclutions = () => {
    this.executeExclutionRules(null);
  };

  setLoader = async ({ show, message }) => {
    this.setState({
      templateLoading: null,
      dialogLoader: {
        show,
        message,
      },
    });
  };

  openLoader = (message) => {
    this.setLoader({
      show: true,
      message,
    });
  };

  closeLoader = () => {
    this.setLoader({
      show: false,
      message: "Procesando",
    });
  };

  toggleSwitch = () => {
    const stateSwitch = !this.state.switch;
    this.setState({
      switch: stateSwitch,
    });
  };

  getClassSelectedTab = (index) => {
    return this.state.selectedTab === index ? "selected" : "";
  };

  onCloseModal = () => {
    this.setState({
      openModalExclu: false,
    });
  };

  handleSelectedTab = (evt) => {
    const indexSelected = evt.target.dataset.index;
    this.setState({
      selectedTab: indexSelected,
    });
    switch (indexSelected) {
      case "EXCLUSIONES":
        const cards =
          this.props.countriesCode === "mdcolombia"
            ? {
                cardZone: this.state.cardZone,
                cardOffices: this.state.cardOffices,
                cardDistribution: this.state.cardDistribution,
                cardChannel: this.state.cardChannel,
                cardSubChannel: this.state.cardSubChannel,
                cardBusinessType: this.state.cardBusinessType,
                //cardClients: this.state.cardClients,
                cardClientsExclusions: this.state.cardClientsExclusions,
                cardClientsExceptions: this.state.cardClientsExceptions,
                cardState: this.state.cardState,
                cardCity: this.state.cardCity,
              }
            : {
                cardDRV: this.state.cardDRV,
                cardZoneMX: this.state.cardZoneMX,
                cardBusinessType: this.state.cardBusinessType,
                //cardClients: this.state.cardClients,
                cardClientsExclusions: this.state.cardClientsExclusions,
                cardClientsExceptions: this.state.cardClientsExceptions,
              };
        this.setState({
          tabView: (
            <DashboardExclutions
              selectedCountry={this.state.selectedCountryCode}
              cards={cards}
            />
          ),
          stateTabsView: false,
        });

        break;
      case "SKU LIMITS":
        this.setState({
          tabView: <DashboardSKULimits rows={this.state.clients} />,
          stateTabsView: true,
        });
        break;
      default:
        this.setState({
          tabView: null,
          stateTabsView: false,
        });
    }
  };

  handleCountryUpdate = (countryName, countryCode) => {
    this.setState({
      selectedCountryPrev: countryName,
      selectedCountryCodePrev: countryCode,
    });

    if (this.state.selectedProduct === " - ") {
      this.setState({
        selectedCountry: countryName,
        selectedCountryCode: countryCode,
      });
      this.changeProduct({
        selectedValue: countryCode,
      });
    } else {
      this.setState({
        dialogAlert: true,
      });
    }
  };

  changeProduct = ({ selectedValue }) => {
    this.emptyExclutions();

    this.fetchProducts({ country: selectedValue });

    this.fetchExclutions({ country: selectedValue });
  };

  //TODO: Autocomplete SKU
  handleAutocomplete = async (evt, value, reason) => {
    if (value) {
      this.setState({
        buttonUpdateDisabled: false,
        selectedProduct: ` - ${value.description}`,
        valueSku:
          this.props.countriesCode === "mdcolombia"
            ? value.sku.substr(13)
            : value.sku.substr(11),
        valueProduct: value,
        switch: value.deactivated === "0" ? true : false,
        openModalExclu: true,
      });
      await this.fetchExclutionsRules(value.sku);
    }
  };

  //TODO: Aceptar BTN Alert
  handleButtonAcceptAlert = (callbackAccept) => {
    this.emptyExclutions();
    this.setState({
      dialogAlert: false,
      selectedCountry: this.state.selectedCountryPrev,
      selectedCountryCode: this.state.selectedCountryCodePrev,
    });
    this.changeProduct({
      selectedValue: this.state.selectedCountryCodePrev,
    });
  };

  //TODO: Aceptar BTN cancel
  handleButtonCancelAlert = () => {
    this.setState({
      dialogAlert: false,
    });
  };

  enableCard = (activate) => {
    const overlays = document.getElementsByClassName(
      "exclutions__card__overlay"
    );
    for (let index in overlays) {
      if (typeof overlays[index] === "object")
        overlays[index].style.display = activate ? "none" : "block";
    }
  };

  //TODO: reglas de exlucion
  fetchExclutionsRules = async (sku) => {
    this.openLoader(`Consultando SKU ${sku.substring(13)}`);

    let serviceURL = env.REACT_APP_SERVICES_GET_EXCLUTIONS_RULES_SKU;
    serviceURL = serviceURL.replace(
      "<countryCode>",
      this.state.selectedCountryCode
    );

    await fetchAPI({
      service: serviceURL + sku,
      protocol: "GET",
      params: {
        codeCountry: this.state.selectedCountryCode,
      },
      callbackThen: (response) => {
        this.executeExclutionRules(null);
        //this.executeExclutionRules(response);
        const cardClientsExceptions = this.state.cardClientsExceptions;
        delete cardClientsExceptions.filtered;
        const cardClientsExclusions = this.state.cardClientsExclusions;
        delete cardClientsExclusions.filtered;
        this.enableCard(true);
        this.setState({
          cardClientsExceptions: cardClientsExceptions,
          cardClientsExclusions: cardClientsExclusions,
          respuesta: Array.isArray(response) ? response : [],
          value: 0,
        });
      },
      callbackError: (error) => {
        this.setState({
          cardClients: {
            title: "Clientes",
            id: "clients",
          },
          cardClientsExceptions: {
            title: "Clientes con excepción",
            service: env.REACT_APP_SERVICES_INFINITI_CLIENTS,
            id: "clients_exception",
            properties: { id: ["cust_no", "name"] },
            rules: [],
          },
          cardClientsExclusions: {
            title: "Clientes con exclusión",
            service: env.REACT_APP_SERVICES_INFINITI_CLIENTS,
            id: "clients",
            properties: { id: ["cust_no", "name"] },
            rules: [],
          },
        });
        this.enableCard(true);
      },
    });

    this.setState({
      rules: [],
      selectedDateStart: null,
      selectedDateEnd: null,
      hoursModificate: "",
      value: 0,
    });

    this.closeLoader();
  };

  executeExclutionRules = async (batch) => {
    try {
      if (batch) {
        await this.fetchRuleByBatch(batch.id);
      } else {
        this.setState({
          rules: null,
          selectedDateStart: null,
          selectedDateEnd: null,
          hoursModificate: null,
          selectedGroupData: null,
        });
        await this.setDataRules(null);
      }
    } catch (e) {
      console.log("error 420 ", e);
    }
  };

  updateExecuteExclusionRules = async (response) => {
    try {
      let dateArr, dateStart, dateEnd;
      let hourArr;
      if (response) {
        hourArr = response.updated_at.split(".");
        if (response.expDate !== null) {
          dateArr = response.expDate.split("T");
          const dateArrTemp = dateArr[0].split("-");
          dateEnd =
            dateArrTemp[1] + "/" + dateArrTemp[2] + "/" + dateArrTemp[0];
        } else {
          dateEnd = null;
        }
        if (response.startDate !== null) {
          dateArr = response.startDate.split("T");
          const dateArrTemp = dateArr[0].split("-");
          dateStart =
            dateArrTemp[1] + "/" + dateArrTemp[2] + "/" + dateArrTemp[0];
        } else {
          dateStart = null;
        }
      }
      this.setState({
        rules: response?.rule,
        selectedDateStart: dateStart ? dateStart : null,
        selectedDateEnd: dateEnd ? dateEnd : null,
        hoursModificate: hourArr ? hourArr[0] : null,
        selectedGroupData: response,
      });
      await this.setDataRules(response);
    } catch (e) {
      console.log("error 420 ", e);
    }
  };

  fetchRuleByBatch = async (batchId) => {
    this.openLoader(
      `Consultando Grupo ${
        this.state.respuesta.findIndex((x) => x.id === batchId) + 1
      }`
    );

    let serviceURL = env.REACT_APP_SERVICES_GET_BATCH_EXCLUTIONS_RULES_SKU;
    serviceURL = serviceURL
      .replace("<countryCode>", this.state.selectedCountryCode)
      .replace("<exclusionID>", batchId);
    await fetchAPI({
      service: serviceURL,
      protocol: "GET",
      params: {
        codeCountry: this.state.selectedCountryCode,
      },
      callbackThen: async (response) => {
        try {
          await this.updateExecuteExclusionRules(response);
        } catch (e) {
          console.log(e);
        }
        this.closeLoader();
      },
      callbackError: (error) => {
        this.setState({
          cardClients: {
            title: "Clientes",
            id: "clients",
          },
          cardClientsExceptions: {
            title: "Clientes con excepción",
            id: "clients",
          },
          cardClientsExclusions: {
            title: "Clientes con exclusión",
            id: "clients_exception",
          },
        });
        this.enableCard(true);
        this.closeLoader();
      },
    });
  };

  setDataRules = async (batch) => {
    const rules = batch?.rule;

    this.clientsExclusion = [];
    this.clientsException = [];

    // TODO: Optimize
    let objCards = {};
    switch (this.props.countriesCode) {
      case "mdcolombia":
        objCards = {
          cardZone: {
            ...this.state.cardZone,
            rules: rules ? rules.sales_orgs || [] : [],
          },
          cardOffices: {
            ...this.state.cardOffices,
            rules: rules ? rules.offices || [] : [],
          },
          cardDistribution: {
            ...this.state.cardDistribution,
            rules: rules ? rules.plants || [] : [],
          },
          cardChannel: {
            ...this.state.cardChannel,
            rules: rules ? rules.channels || [] : [],
          },
          cardSubChannel: {
            ...this.state.cardSubChannel,
            rules: rules ? rules.subchannels || [] : [],
          },
          cardBusinessType: {
            ...this.state.cardBusinessType,
            rules: rules ? rules.business_types || [] : [],
          },
          cardState: {
            ...this.state.cardState,
            rules: rules ? rules.regions || [] : [],
          },
          cardCity: {
            ...this.state.cardCity,
            rules: rules ? rules.municipalities || [] : [],
          },
        };

        if (batch?.id) {
          this.openLoader(`Consultando clientes`);
          this.clientsExclusion = await this.getClientsData(
            batch?.countClientsExclusion || 0,
            "clients",
            batch?.id
          );
          this.clientsException = await this.getClientsData(
            batch?.countClientsException || 0,
            "clients_exception",
            batch?.id
          );
        }

        break;
      case "mdmexico":
        objCards = {
          cardZoneMX: { // Zona
            ...this.state.cardZoneMX,
            rules: rules ? rules.zone || [] : [],
          },
          cardZone: { // ORG
            ...this.state.cardZone,
            rules: rules ? rules.org || [] : [],
          },
          cardDistribution: { // PLANT O CENTO
            ...this.state.cardDistribution,
            rules: rules ? rules.sales_orgs || [] : [],
          },
          cardBusinessType: {
            ...this.state.cardBusinessType,
            rules: rules ? rules.segment_concesionarios || [] : [],
          },
        };
        if (batch?.id) {
          this.openLoader(`Consultando clientes`);
          this.clientsExclusion = await this.getClientsData(
              batch?.countClientsExclusion || 0,
              "clients",
              batch?.id
          );
          this.clientsException = await this.getClientsData(
              batch?.countClientsException || 0,
              "clients_exception",
              batch?.id
          );
        }
        break;
      default:
        break;
    }

    this.setState({
      ...objCards,
      cardClientsExceptions: {
        ...this.state.cardClientsExceptions,
        rules:
          (this.props.countriesCode === "mdcolombia" || this.props.countriesCode === "mdmexico")
            ? this.clientsException
            : rules
            ? rules.clients_exception || []
            : [],
        countClients:
            (this.props.countriesCode === "mdcolombia" || this.props.countriesCode === "mdmexico")
            ? batch?.countClientsException
            : null,
      },
      cardClientsExclusions: {
        ...this.state.cardClientsExclusions,
        rules:
            (this.props.countriesCode === "mdcolombia" || this.props.countriesCode === "mdmexico")
            ? this.clientsExclusion
            : rules
            ? rules.clients || []
            : [],
        countClients:
            (this.props.countriesCode === "mdcolombia" || this.props.countriesCode === "mdmexico")
            ? batch?.countClientsExclusion
            : null,
      },
    });
  };

  fetchClients = async (URL, { page = 1, limit = 5000, exclusion = true }) => {
    let newUrl = URL.replace("<page>", page + 1);
    newUrl = newUrl.replace("<limit>", limit);
    newUrl = newUrl.replace("<exclusion>", exclusion);

    return new Promise((resolve, reject) => {
      fetchAPI({
        service: newUrl,
        protocol: "GET",
        params: {
          codeCountry: this.state.selectedCountryCode,
        },
        callbackThen: (response) => {
          resolve(response);
        },
        callbackError: (error) => {
          reject(error);
        },
      });
    });
  };

  getClientsData = async (countClients, type, batchId) => {
    const limit = parseInt(env.REACT_APP_DIVIDER_CLIENTS, 10) || 5000;
    const parts = Array(Math.ceil(countClients / limit)).keys();

    let URL = env.REACT_APP_SERVICES_INFINITI_CLIENTS;
    URL = URL.replace("<countryCode>", this.state.selectedCountryCode);
    URL = URL.replace("<batchId>", batchId);

    const getClient = async (ite, arr = []) => {
      const part = ite.next();
      if (part.done) return arr;
      const clients = await this.fetchClients(URL, {
        page: part.value,
        limit,
        exclusion: type === "clients",
      });
      arr = [...arr, ...clients];
      return getClient(ite, arr);
    };

    return getClient(iterator(Array.from(parts)));
  };

  //TODO: consulta de paises
  fetchCountries = async () => {
    fetchAPI({
      service: env.REACT_APP_SERVICES_GET_COUNTRIES,
      protocol: "GET",
      params: {
        codeCountry: this.state.selectedCountryCode,
      },
      callbackThen: (response) => {
        try {
          const firstOption = [{ name: "Selecciona un país", code: "0" }];
          const options = firstOption.concat(response);
          for (var option in options) {
            if (options[option].name === "Colombia") {
              this.setState({
                availableCountries: options,
                selectedCountry: options[option].name,
                selectedCountryCode: options[option].code,
              });
              this.handleCountryUpdate(
                options[option].name,
                options[option].code
              );
            }
          }
          this.fetchProducts({ country: options[0].code });
          this.fetchExclutions({ country: options[0].code });
        } catch (e) {
          this.setState({
            availableCountries: [],
            selectedCountry: "No existen países",
          });
        }
      },
    });
  };

  fetchProducts = async ({ country }) => {
    this.openLoader("Consultando productos");

    const selectedCountryCode =
      typeof country !== "undefined" ? country : this.state.selectedCountryCode;

    if (selectedCountryCode !== "0") {
      await fetchAPI({
        service:
          env.REACT_APP_SERVICES_GET_PRODUCTS + "/" + selectedCountryCode,
        protocol: "GET",
        params: {
          codeCountry: selectedCountryCode,
        },
        callbackThen: (response) => {
          try {
            this.setState({
              products: response,
            });
          } catch (e) {
            console.log(e);
          }
          this.closeLoader();
        },
      });
    } else {
      this.emptyExclutions();
    }
  };

  fetchExclutions = async ({ country }) => {
    const selectedCountryCode =
      typeof country !== "undefined" ? country : this.state.selectedCountryCode;

    if (selectedCountryCode !== "0") {
      //Fetch for Zones provisional
      fetchAPI({
        service:
          this.props.countriesCode === "mdcolombia"
            ? env.REACT_APP_SERVICES_GET_ORGANIZATIONS +
              "/" +
              selectedCountryCode
            : "v1/channels-structure/segment/mdmexico",
        protocol: "GET",
        params: {
          codeCountry: selectedCountryCode,
        },
        callbackThen: (response) => {
          try {
            this.setState({
              cardZone: {
                title:
                  this.props.countriesCode === "mdcolombia"
                    ? "Zona"
                    : "Segmento",
                elements: response,
                filtered: response,
                id: "zone",
              },
              loadedCards: this.state.loadedCards + 1,
            });
          } catch (e) {
            console.log(e);
          }
        },
      });

      //Fetch for Offices
      fetchAPI({
        service:
          this.props.countriesCode === "mdcolombia"
            ? env.REACT_APP_SERVICES_GET_OFFICES + "/" + selectedCountryCode
            : "v1/sales-structure/office/mdmexico",
        protocol: "GET",
        params: {
          codeCountry: selectedCountryCode,
        },
        callbackThen: (response) => {
          try {
            this.setState({
              cardOffices: {
                title: "Direccion Regional de Ventas",
                elements: response,
                filtered: response,
                id: "offices",
              },
              loadedCards: this.state.loadedCards + 1,
            });
          } catch (e) {
            console.log(e);
          }
        },
      });

      //segmentacion
      fetchAPI({
        service: "v1/channels-structure/segment/mdmexico",
        protocol: "GET",
        params: {
          codeCountry: selectedCountryCode,
        },
        callbackThen: (response) => {
          try {
            this.setState({
              cardSegments: {
                title: "Canal",
                elements: response,
                filtered: response,
                id: "segments",
              },
              loadedCards: this.state.loadedCards + 1,
            });
          } catch (e) {
            console.log(e);
          }
        },
      });

      //Fetch for Distribution
      fetchAPI({
        service:
          env.REACT_APP_SERVICES_GET_DISTRIBUTION + "/" + selectedCountryCode,
        protocol: "GET",
        params: {
          codeCountry: selectedCountryCode,
        },
        callbackThen: (response) => {
          try {
            this.setState({
              cardDistribution: {
                title: "Centro de Distribución",
                elements: response,
                filtered: response,
                id: "distribution",
              },
              loadedCards: this.state.loadedCards + 1,
            });
          } catch (e) {
            console.log(e);
          }
        },
      });

      //Fetch for Channels
      fetchAPI({
        service: env.REACT_APP_SERVICES_GET_CHANNEL + "/" + selectedCountryCode,
        protocol: "GET",
        params: {
          codeCountry: selectedCountryCode,
        },
        callbackThen: (response) => {
          try {
            this.setState({
              cardChannel: {
                title: "Canal",
                elements: response,
                filtered: response,
                id: "channel",
              },
              loadedCards: this.state.loadedCards + 1,
            });
          } catch (e) {
            console.log(e);
          }
        },
      });

      //Fetch for Subchannels
      fetchAPI({
        service:
          env.REACT_APP_SERVICES_GET_SUBCHANNEL + "/" + selectedCountryCode,
        protocol: "GET",
        params: {
          codeCountry: selectedCountryCode,
        },
        callbackThen: (response) => {
          try {
            this.setState({
              cardSubChannel: {
                title: "Subcanal",
                elements: response,
                filtered: response,
                id: "subchannel",
              },
              loadedCards: this.state.loadedCards + 1,
            });
          } catch (e) {
            console.log(e);
          }
        },
      });

      //Fetch for Business Type
      fetchAPI({
        service:
          this.props.countriesCode === "mdcolombia"
            ? `v1/channels-structure/business-type/${selectedCountryCode}`
            : `v1/channels-structure/segment/${selectedCountryCode}`,
        protocol: "GET",
        params: {
          codeCountry: selectedCountryCode,
        },
        callbackThen: (response) => {
          try {
            this.setState({
              cardBusinessType: {
                title:
                  this.props.countriesCode === "mdcolombia"
                    ? "Tipo de negocio"
                    : "Canal - Segmentos",
                elements: response,
                filtered: response,
                id: "business-type",
              },
              loadedCards: this.state.loadedCards + 1,
            });
          } catch (e) {
            console.log(e);
          }
        },
      });

      //Fetch for States
      fetchAPI({
        service:
          env.REACT_APP_SERVICES_GET_MUNICIPALITY + "/" + selectedCountryCode,
        protocol: "GET",
        params: {
          codeCountry: selectedCountryCode,
        },
        callbackThen: (response) => {
          try {
            this.setState({
              cardState: {
                title: "Estado/Departamento",
                elements: response,
                filtered: response,
                id: "state",
              },
              loadedCards: this.state.loadedCards + 1,
            });
          } catch (e) {
            console.log(e);
          }
        },
      });

      //Fetch for City
      fetchAPI({
        service: env.REACT_APP_SERVICES_GET_REGION + "/" + selectedCountryCode,
        protocol: "GET",
        params: {
          codeCountry: selectedCountryCode,
        },
        callbackThen: (response) => {
          try {
            this.setState({
              cardCity: {
                title: "Ciudad",
                elements: response,
                filtered: response,
                id: "city",
              },
              loadedCards: this.state.loadedCards + 1,
            });
          } catch (e) {
            console.log(e);
          }
        },
      });
    } else {
      this.emptyExclutions();
    }
  };

  setRule = (id, rules) => {
    const list = document
      .getElementById("card-exclutions-list-" + id)
      .getElementsByTagName("li");
    for (const element in list) {
      if (typeof list[element] === "object") {
        const key = list[element].getElementsByTagName("input")[0].dataset.key;
        for (const rule in rules) {
          const ruleKey = rules[rule];
          if (ruleKey === key) {
            list[element].getElementsByTagName("input")[0].click();
          }
        }
      }
    }
    document
      .getElementById("card-exclutions-container-" + id)
      .getElementsByClassName("exclutions__card__overlay")[0].style.display =
      "none";
  };

  setRules = async (rules) => {
    switch (this.props.countriesCode) {
      case "mdcolombia":
        this.setRule("zone", rules ? rules.sales_orgs : {});
        this.setRule("offices", rules ? rules.offices : {});
        this.setRule("distribution", rules ? rules.plants : {});
        this.setRule("channel", rules ? rules.channels : {});
        this.setRule("subchannel", rules ? rules.subchannels : {});
        this.setRule("business-type", rules ? rules.business_types : {});
        this.setRule("state", rules ? rules.regions : {});
        this.setRule("city", rules ? rules.municipalities : {});
        break;
      case "mdmexico":
        // this.setRule("zone", rules.sales_orgs );
        // this.setRule("offices", rules.offices);
        // this.setRule("business-type", rules.business_types);
        break;
      default:
        break;
    }
    //Set clients on list
    const arrClients = [];
    const arrClientException = [];
    const arrClasification = [];
    if (rules)
      for (const rule in rules.clients) {
        arrClients.push({
          deactivated: "0",
          id: rules.clients[rule],
          name: rules.clients[rule],
        });
      }
    if (rules)
      for (const rule in rules.clients_exception) {
        arrClientException.push({
          deactivated: "0",
          id: rules.clients_exception[rule],
          name: rules.clients_exception[rule],
        });
      }
    if (rules)
      for (const rule in rules.Clasification) {
        arrClasification.push({
          deactivated: "0",
          id: rules.clasification[rule],
          name: rules.clasification[rule],
        });
      }

    /*this.setState({
      cardClients: {
        title: "Clientes",
        id: "clients"
      },
      cardSegmento: {
        title: "Segmento",
        id: "clasifications"
      },
      cardClientsExceptions:{
        title: "Clientes con excepción",
        id: "clients"
      },
      cardClientsExclusions:{
        title: "Clientes con exclusión",
        id: "clients_exception"
      }
    });*/

    this.setClients(arrClients);
    this.setClientsException(arrClientException);
    this.setClasification(arrClasification);

    await this.checkedAllClients();
  };

  checkedAllClients = async () => {
    function sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    }

    await sleep(2000);

    let list = document
      .getElementById("card-exclutions-list-clients_exception")
      .getElementsByTagName("li");
    for (const element in list) {
      if (typeof list[element] === "object") {
        if (!list[element].getElementsByTagName("input")[0].checked) {
          list[element].getElementsByTagName("input")[0].click();
        }
      }
    }

    document
      .getElementById("card-exclutions-container-clients_exception")
      .getElementsByClassName("exclutions__card__overlay")[0].style.display =
      "none";

    list = document
      .getElementById("card-exclutions-list-clients")
      .getElementsByTagName("li");
    for (const element in list) {
      if (typeof list[element] === "object") {
        if (!list[element].getElementsByTagName("input")[0].checked) {
          list[element].getElementsByTagName("input")[0].click();
        }
      }
    }

    document
      .getElementById("card-exclutions-container-clients")
      .getElementsByClassName("exclutions__card__overlay")[0].style.display =
      "none";

    document
      .getElementById("exclutions-actions-container")
      .getElementsByClassName("exclutions__card__overlay")[0].style.display =
      "none";
  };

  onlySetCliets = async (clients) => {
    const arrClients = [
      ...(this.state.cardClientsExclusions.rules || []),
      ...clients,
    ];
    this.setClients([...new Set(arrClients)]);
    // await this.checkedAllClients();
  };

  onlySetClientsException = async (clientsException) => {
    const arrClients = [
      ...(this.state.cardClientsExceptions.rules || []),
      ...clientsException,
    ];
    this.setClientsException([...new Set(arrClients)]);
    // await this.checkedAllClients();
  };

  setClients(clients) {
    this.setState({
      cardClientsExclusions: {
        title: "Clientes con exclusión",
        id: "clients",
        properties: { id: ["cust_no", "name"] },
        rules: clients,
      },
    });
  }

  setClientsException(clients_exception) {
    this.setState({
      cardClientsExceptions: {
        title: "Clientes con excepción",
        id: "clients_exception",
        properties: { id: ["cust_no", "name"] },
        rules: clients_exception,
      },
    });
  }

  setClasification(clasifications) {
    this.setState({
      clasification: clasifications,
    });
  }

  setSelectedCountry = (country) => {
    this.setState({
      selectedCountry: country,
    });
  };

  setSelectedDateStart = (date) => {
    this.setState({
      selectedDateStart: date ? date : null,
    });
  };

  /*
  setSelectedDateEnd = (date) => {
    const dateEnd = date ? new Date(date).toLocaleDateString("en-US") : null;
    this.setState({
      selectedDateEnd: dateEnd,
    });
  };*/
  /*
  getFilteredText = (text, elements) => {
    let filtered = [];
    if(text !== "") {
      filtered = elements.filter(function(element) {
        const elementText = element.id + element.name;
        return elementText.toLowerCase().includes(text.toLowerCase());
      });
    } else {
      filtered = elements;
    }
    return filtered;
  }

  filterCards = (text, type) => {
    let filtered = [];
    let elements = [];
    switch (this.props.countriesCode) {
      case 'mdcolombia':
        switch(type) {
          case 'zone':
            elements = this.state.cardZone.elements;
            filtered = this.getFilteredText(text, elements);
            this.setState({
              cardZone: {
                title: "Zona",
                elements: this.state.cardZone.elements,
                filtered: filtered,
                id: "zone",
              },
            });
            break;
          case 'offices':
            elements = this.state.cardOffices.elements;
            filtered = this.getFilteredText(text, elements);
            this.setState({
              cardOffices: {
                title: "Direccion Regional de Ventas",
                elements: this.state.cardOffices.elements,
                filtered: filtered,
                id: "offices",
              },
            });
            break;
          case 'distribution':
            elements = this.state.cardDistribution.elements;
            filtered = this.getFilteredText(text, elements);
            this.setState({
              cardDistribution: {
                title: "Centro de Distribución",
                elements: this.state.cardDistribution.elements,
                filtered: filtered,
                id: "distribution",
              },
            });
            break;
          case 'channel':
            elements = this.state.cardChannel.elements;
            filtered = this.getFilteredText(text, elements);
            this.setState({
              cardChannel: {
                title: "Canal",
                elements: this.state.cardChannel.elements,
                filtered: filtered,
                id: "channel",
              },
            });
            break;
          case 'subchannel':
            elements = this.state.cardSubChannel.elements;
            filtered = this.getFilteredText(text, elements);
            this.setState({
              cardSubChannel: {
                title: "Subcanal",
                elements: this.state.cardSubChannel.elements,
                filtered: filtered,
                id: "subchannel",
              },
            });
            break;
          case 'business-type':
            elements = this.state.cardBusinessType.elements;
            filtered = this.getFilteredText(text, elements);
            this.setState({
              cardBusinessType: {
                title:"Tipo de negocio",
                elements: this.state.cardBusinessType.elements,
                filtered: filtered,
                id: "business-type",
              },
            });
            break;
          case 'state':
            elements = this.state.cardState.elements;
            filtered = this.getFilteredText(text, elements);
            this.setState({
              cardState: {
                title: "Estado/Departamento",
                elements: this.state.cardState.elements,
                filtered: filtered,
                id: "state",
              },
            });
            break;
          case 'city':
            elements = this.state.cardCity.elements;
            filtered = this.getFilteredText(text, elements);
            this.setState({
              cardCity: {
                title: "Ciudad",
                elements: this.state.cardCity.elements,
                filtered: filtered,
                id: "city",
              },
            });
            break;
          default:
            console.log(null);
        }
        break;
      case 'mdmexico':
        switch (type) {
          case 'business-type':
            elements = this.state.cardBusinessType.elements;
            filtered = this.getFilteredText(text, elements);
            this.setState({
              cardBusinessType: {
                title:"Canal - Segmentos",
                elements: this.state.cardBusinessType.elements,
                filtered: filtered,
                id: "business-type",
              },
            });
            break;
          // case 'zone':
          //   elements = this.state.cardZone.elements;
          //   filtered = this.getFilteredText(text, elements);
          //   this.setState({
          //     cardZone: {
          //       title: "Segmento",
          //       elements: this.state.cardZone.elements,
          //       filtered: filtered,
          //       id: "zone",
          //     },
          //   });
          //   break;
          case 'offices':
            elements = this.state.cardOffices.elements;
            filtered = this.getFilteredText(text, elements);
            this.setState({
              cardOffices: {
                title: "Direccion Regional de Ventas",
                elements: this.state.cardOffices.elements,
                filtered: filtered,
                id: "offices",
              },
            });
            break;
        
          default:
            console.log(null);
            break;
        }
        break;
      default:
        console.log(null);
        break;



    }
  }

  clearFilter = (type) => {
    switch (this.props.countriesCode) {
      case 'mdcolombia':
        switch(type) {
          case 'zone':
            this.setState({
              cardZone: {
                title: "Zona",
                elements: this.state.cardZone.elements,
                filtered: this.state.cardZone.elements,
                id: "zone",
              },
            });
            break;
          case 'offices':
            this.setState({
              cardOffices: {
                title: "Direccion Regional de Ventas",
                elements: this.state.cardOffices.elements,
                filtered: this.state.cardOffices.elements,
                id: "offices",
              },
            });
            break;
          case 'distribution':
            this.setState({
              cardDistribution: {
                title: "Centro de Distribución",
                elements: this.state.cardDistribution.elements,
                filtered: this.state.cardDistribution.elements,
                id: "distribution",
              },
            });
            break;
          case 'channel':
            this.setState({
              cardChannel: {
                title: "Canal",
                elements: this.state.cardChannel.elements,
                filtered: this.state.cardChannel.elements,
                id: "channel",
              },
            });
            break;
          case 'subchannel':
            this.setState({
              cardSubChannel: {
                title: "Subcanal",
                elements: this.state.cardSubChannel.elements,
                filtered: this.state.cardSubChannel.elements,
                id: "subchannel",
              },
            });
            break;
          case 'business-type':
            this.setState({
              cardBusinessType: {
                title: "Tipo de negocio",
                elements: this.state.cardBusinessType.elements,
                filtered: this.state.cardBusinessType.elements,
                id: "business-type",
              },
            });
            break;
          case 'state':
            this.setState({
              cardState: {
                title: "Estado/Departamento",
                elements: this.state.cardState.elements,
                filtered: this.state.cardState.elements,
                id: "state",
              },
            });
            break;
          case 'city':
            this.setState({
              cardCity: {
                title: "Ciudad",
                elements: this.state.cardCity.elements,
                filtered: this.state.cardCity.elements,
                id: "city",
              },
            });
            break;
          default:
            console.log(null);
        }
        break;
      case 'mdmexico':
        switch (type) {
          // case 'zone':
          //   this.setState({
          //     cardZone: {
          //       title: "Segmento",
          //       elements: this.state.cardZone.elements,
          //       filtered: this.state.cardZone.elements,
          //       id: "zone",
          //     },
          //   });
          //   break;
          
            case 'business-type':
              this.setState({
                cardBusinessType: {
                  title:"Canal - Segmentos",
                  elements: this.state.cardBusinessType.elements,
                  filtered: this.state.cardBusinessType.elements,
                  id: "business-type",
                },
              });
              break;

            case 'offices':
              this.setState({
                cardOffices: {
                  title: "Direccion Regional de Ventas",
                  elements: this.state.cardOffices.elements,
                  filtered: this.state.cardOffices.elements,
                  id: "offices",
                },
              });
              break;
        
          default:
            console.log(null);
        }
        break;
    
      default:
        console.log(null);
    }
    // switch(type) {
    //   case 'zone':
    //     this.setState({
    //       cardZone: {
    //         title: "Zona",
    //         elements: this.state.cardZone.elements,
    //         filtered: this.state.cardZone.elements,
    //         id: "zone",
    //       },
    //     });
    //     break;
    //   case 'offices':
    //     this.setState({
    //       cardOffices: {
    //         title: "Gerencia de Ventas",
    //         elements: this.state.cardOffices.elements,
    //         filtered: this.state.cardOffices.elements,
    //         id: "offices",
    //       },
    //     });
    //     break;
    //   case 'distribution':
    //     this.setState({
    //       cardDistribution: {
    //         title: this.props.countriesCode === "mdcolombia" ? "Centro de Distribución" : "UEN",
    //         elements: this.state.cardDistribution.elements,
    //         filtered: this.state.cardDistribution.elements,
    //         id: this.props.countriesCode === "mdcolombia" ? "distribution" : "UEN",
    //       },
    //     });
    //     break;
    //   case 'channel':
    //     this.setState({
    //       cardChannel: {
    //         title: "Canal",
    //         elements: this.state.cardChannel.elements,
    //         filtered: this.state.cardChannel.elements,
    //         id: "channel",
    //       },
    //     });
    //     break;
    //   case 'subchannel':
    //     this.setState({
    //       cardSubChannel: {
    //         title: "Subcanal",
    //         elements: this.state.cardSubChannel.elements,
    //         filtered: this.state.cardSubChannel.elements,
    //         id: "subchannel",
    //       },
    //     });
    //     break;
    //   case 'business-type':
    //     this.setState({
    //       cardBusinessType: {
    //         title: this.props.countriesCode === "mdcolombia" ? "Tipo de negocio" : "Tipificación de clientes",
    //         elements: this.state.cardBusinessType.elements,
    //         filtered: this.state.cardBusinessType.elements,
    //         id: "business-type",
    //       },
    //     });
    //     break;
    //   case 'state':
    //     this.setState({
    //       cardState: {
    //         title: "Estado/Departamento",
    //         elements: this.state.cardState.elements,
    //         filtered: this.state.cardState.elements,
    //         id: "state",
    //       },
    //     });
    //     break;
    //   case 'city':
    //     this.setState({
    //       cardCity: {
    //         title: "Ciudad",
    //         elements: this.state.cardCity.elements,
    //         filtered: this.state.cardCity.elements,
    //         id: "city",
    //       },
    //     });
    //     break;
    //   default:
    //     console.log(null);
    // }
  }

  welcome(){
    const {root,card,table,} = this.useStyles();
  } */

  setSelectedDateEnd = (date) => {
    this.setState({
      selectedDateEnd: date ? date : null,
    });
  };

  getFilteredText = (text, elements, id = null) => {
    let filtered = [];
    if (text !== "") {
      filtered = elements.filter(function (element) {
        let elementText = "";
        switch (id) {
          case "zone":
            elementText =
              element.id + element.name + element.org_name + element.zone_name;
            return elementText.toLowerCase().includes(text.toLowerCase());
            break;
          case "clients":
            elementText = element.id.cust_no + element.id.name;
            return elementText.toLowerCase().includes(text.toLowerCase());
            break;
          default:
            elementText = element.id + element.name;
            return elementText.toLowerCase().includes(text.toLowerCase());
            break;
        }
      });
    } else {
      filtered = elements;
    }
    return filtered;
  };

  filterCards = (text, type) => {
    let filtered = [];
    let elements = [];
    switch (this.props.countriesCode) {
      case "mdcolombia":
        switch (type) {
          case "zone":
            elements = this.state.cardZone.elements;
            filtered = this.getFilteredText(text, elements);
            this.setState({
              cardZone: {
                title: "Zona",
                elements: this.state.cardZone.elements,
                filtered: filtered,
                id: "zone",
              },
            });
            break;
          case "offices":
            elements = this.state.cardOffices.elements;
            filtered = this.getFilteredText(text, elements);
            this.setState({
              cardOffices: {
                title: "Direccion Regional de Ventas",
                elements: this.state.cardOffices.elements,
                filtered: filtered,
                id: "offices",
              },
            });
            break;
          case "distribution":
            elements = this.state.cardDistribution.elements;
            filtered = this.getFilteredText(text, elements);
            this.setState({
              cardDistribution: {
                title: "Centro de Distribución",
                elements: this.state.cardDistribution.elements,
                filtered: filtered,
                id: "distribution",
              },
            });
            break;
          case "channel":
            elements = this.state.cardChannel.elements;
            filtered = this.getFilteredText(text, elements);
            this.setState({
              cardChannel: {
                title: "Canal",
                elements: this.state.cardChannel.elements,
                filtered: filtered,
                id: "channel",
              },
            });
            break;
          case "subchannel":
            elements = this.state.cardSubChannel.elements;
            filtered = this.getFilteredText(text, elements);
            this.setState({
              cardSubChannel: {
                title: "Subcanal",
                elements: this.state.cardSubChannel.elements,
                filtered: filtered,
                id: "subchannel",
              },
            });
            break;
          case "business-type":
            elements = this.state.cardBusinessType.elements;
            filtered = this.getFilteredText(text, elements);
            this.setState({
              cardBusinessType: {
                title: "Tipo de negocio",
                elements: this.state.cardBusinessType.elements,
                filtered: filtered,
                id: "business-type",
              },
            });
            break;
          case "state":
            elements = this.state.cardState.elements;
            filtered = this.getFilteredText(text, elements);
            this.setState({
              cardState: {
                title: "Estado/Departamento",
                elements: this.state.cardState.elements,
                filtered: filtered,
                id: "state",
              },
            });
            break;
          case "city":
            elements = this.state.cardCity.elements;
            filtered = this.getFilteredText(text, elements);
            this.setState({
              cardCity: {
                title: "Ciudad",
                elements: this.state.cardCity.elements,
                filtered: filtered,
                id: "city",
              },
            });
            break;
          case "clients":
            elements = this.state.clients;
            filtered = this.getFilteredText(text, elements, "clients");
            this.setState({
              cardClientsExclusions: {
                title: "Clientes con exclusión",
                elements: this.state.cardClientsExclusions.elements,
                filtered: filtered,
                id: "clients",
              },
            });
            break;
          case "clients_exception":
            elements = this.state.clientsException;
            filtered = this.getFilteredText(text, elements, "clients");
            this.setState({
              cardClientsExceptions: {
                title: "Clientes con excepción",
                elements: this.state.cardClientsExceptions.elements,
                filtered: filtered,
                id: "clients_exception",
              },
            });
            break;
          default:
            console.log(null);
        }
        break;
      case "mdmexico":
        switch (type) {
          case "business-type":
            elements = this.state.cardBusinessType.elements;
            filtered = this.getFilteredText(text, elements);
            this.setState({
              cardBusinessType: {
                title: "Canal - Segmentos",
                elements: this.state.cardBusinessType.elements,
                filtered: filtered,
                id: "business-type",
              },
            });
            break;
          // case 'zone':
          //   elements = this.state.cardZone.elements;
          //   filtered = this.getFilteredText(text, elements);
          //   this.setState({
          //     cardZone: {
          //       title: "Segmento",
          //       elements: this.state.cardZone.elements,
          //       filtered: filtered,
          //       id: "zone",
          //     },
          //   });
          //   break;
          case "offices":
            elements = this.state.cardOffices.elements;
            filtered = this.getFilteredText(text, elements, "zone");
            this.setState({
              cardOffices: {
                title: "Direccion Regional de Ventas",
                elements: this.state.cardOffices.elements,
                filtered: filtered,
                id: "offices",
              },
            });
            break;
          case "clients":
            elements = this.state.clients;
            filtered = this.getFilteredText(text, elements, "clients");
            this.setState({
              cardClientsExclusions: {
                title: "Clientes con exclusión",
                elements: this.state.cardClientsExclusions.elements,
                filtered: filtered,
                id: "clients",
              },
            });
            break;
          case "clients_exception":
            elements = this.state.clientsException;
            filtered = this.getFilteredText(text, elements, "clients");
            this.setState({
              cardClientsExceptions: {
                title: "Clientes con excepción",
                elements: this.state.cardClientsExceptions.elements,
                filtered: filtered,
                id: "clients_exception",
              },
            });
            break;

          default:
            console.log(null);
            break;
        }
        break;
      default:
        console.log(null);
        break;
    }
  };

  clearFilter = (type) => {
    switch (this.props.countriesCode) {
      case "mdcolombia":
        switch (type) {
          case "zone":
            this.setState({
              cardZone: {
                title: "Zona",
                elements: this.state.cardZone.elements,
                filtered: this.state.cardZone.elements,
                id: "zone",
              },
            });
            break;
          case "offices":
            this.setState({
              cardOffices: {
                title: "Direccion Regional de Ventas",
                elements: this.state.cardOffices.elements,
                filtered: this.state.cardOffices.elements,
                id: "offices",
              },
            });
            break;
          case "distribution":
            this.setState({
              cardDistribution: {
                title: "Centro de Distribución",
                elements: this.state.cardDistribution.elements,
                filtered: this.state.cardDistribution.elements,
                id: "distribution",
              },
            });
            break;
          case "channel":
            this.setState({
              cardChannel: {
                title: "Canal",
                elements: this.state.cardChannel.elements,
                filtered: this.state.cardChannel.elements,
                id: "channel",
              },
            });
            break;
          case "subchannel":
            this.setState({
              cardSubChannel: {
                title: "Subcanal",
                elements: this.state.cardSubChannel.elements,
                filtered: this.state.cardSubChannel.elements,
                id: "subchannel",
              },
            });
            break;
          case "business-type":
            this.setState({
              cardBusinessType: {
                title: "Tipo de negocio",
                elements: this.state.cardBusinessType.elements,
                filtered: this.state.cardBusinessType.elements,
                id: "business-type",
              },
            });
            break;
          case "state":
            this.setState({
              cardState: {
                title: "Estado/Departamento",
                elements: this.state.cardState.elements,
                filtered: this.state.cardState.elements,
                id: "state",
              },
            });
            break;
          case "city":
            this.setState({
              cardCity: {
                title: "Ciudad",
                elements: this.state.cardCity.elements,
                filtered: this.state.cardCity.elements,
                id: "city",
              },
            });
            break;
          case "clients":
            this.setState({
              cardClientsExclusions: {
                title: "Clientes con exclusión",
                elements: this.state.cardClientsExclusions.elements,
                filtered: undefined,
                id: "clients",
              },
            });
            break;
          case "clients_exception":
            this.setState({
              cardClientsExceptions: {
                title: "Clientes con excepción",
                elements: this.state.cardClientsExceptions.elements,
                filtered: undefined,
                id: "clients_exception",
              },
            });
            break;
          default:
            console.log(null);
        }
        break;
      case "mdmexico":
        switch (type) {
          // case 'zone':
          //   this.setState({
          //     cardZone: {
          //       title: "Segmento",
          //       elements: this.state.cardZone.elements,
          //       filtered: this.state.cardZone.elements,
          //       id: "zone",
          //     },
          //   });
          //   break;

          case "business-type":
            this.setState({
              cardBusinessType: {
                title: "Canal - Segmentos",
                elements: this.state.cardBusinessType.elements,
                filtered: this.state.cardBusinessType.elements,
                id: "business-type",
              },
            });
            break;

          case "offices":
            this.setState({
              cardOffices: {
                title: "Direccion Regional de Ventas",
                elements: this.state.cardOffices.elements,
                filtered: this.state.cardOffices.elements,
                id: "offices",
              },
            });
            break;
          case "clients":
            this.setState({
              cardClientsExclusions: {
                title: "Clientes con exclusión",
                elements: this.state.cardClientsExclusions.elements,
                filtered: undefined,
                id: "clients",
              },
            });
            break;
          case "clients_exception":
            this.setState({
              cardClientsExceptions: {
                title: "Clientes con excepción",
                elements: this.state.cardClientsExceptions.elements,
                filtered: undefined,
                id: "clients_exception",
              },
            });
            break;
          default:
            console.log(null);
        }
        break;

      default:
        console.log(null);
    }
    // switch(type) {
    //   case 'zone':
    //     this.setState({
    //       cardZone: {
    //         title: "Zona",
    //         elements: this.state.cardZone.elements,
    //         filtered: this.state.cardZone.elements,
    //         id: "zone",
    //       },
    //     });
    //     break;
    //   case 'offices':
    //     this.setState({
    //       cardOffices: {
    //         title: "Gerencia de Ventas",
    //         elements: this.state.cardOffices.elements,
    //         filtered: this.state.cardOffices.elements,
    //         id: "offices",
    //       },
    //     });
    //     break;
    //   case 'distribution':
    //     this.setState({
    //       cardDistribution: {
    //         title: this.props.countriesCode === "mdcolombia" ? "Centro de Distribución" : "UEN",
    //         elements: this.state.cardDistribution.elements,
    //         filtered: this.state.cardDistribution.elements,
    //         id: this.props.countriesCode === "mdcolombia" ? "distribution" : "UEN",
    //       },
    //     });
    //     break;
    //   case 'channel':
    //     this.setState({
    //       cardChannel: {
    //         title: "Canal",
    //         elements: this.state.cardChannel.elements,
    //         filtered: this.state.cardChannel.elements,
    //         id: "channel",
    //       },
    //     });
    //     break;
    //   case 'subchannel':
    //     this.setState({
    //       cardSubChannel: {
    //         title: "Subcanal",
    //         elements: this.state.cardSubChannel.elements,
    //         filtered: this.state.cardSubChannel.elements,
    //         id: "subchannel",
    //       },
    //     });
    //     break;
    //   case 'business-type':
    //     this.setState({
    //       cardBusinessType: {
    //         title: this.props.countriesCode === "mdcolombia" ? "Tipo de negocio" : "Tipificación de clientes",
    //         elements: this.state.cardBusinessType.elements,
    //         filtered: this.state.cardBusinessType.elements,
    //         id: "business-type",
    //       },
    //     });
    //     break;
    //   case 'state':
    //     this.setState({
    //       cardState: {
    //         title: "Estado/Departamento",
    //         elements: this.state.cardState.elements,
    //         filtered: this.state.cardState.elements,
    //         id: "state",
    //       },
    //     });
    //     break;
    //   case 'city':
    //     this.setState({
    //       cardCity: {
    //         title: "Ciudad",
    //         elements: this.state.cardCity.elements,
    //         filtered: this.state.cardCity.elements,
    //         id: "city",
    //       },
    //     });
    //     break;
    //   default:
    //     console.log(null);
    // }
  };

  welcome() {
    const { root, card, table } = this.useStyles();
  }

  render() {
    const switchClass = `products-admin__button-dot ${
      this.state.switch ? "on" : "off"
    }`;
    const switchLabel = this.state.switch ? "Activo" : "Inactivo";
    const cards = {
      cardZone: this.state.cardZone,
      cardZoneMX: this.state.cardZoneMX,
      cardOffices: this.state.cardOffices,
      cardDistribution: this.state.cardDistribution,
      cardChannel: this.state.cardChannel,
      cardSubChannel: this.state.cardSubChannel,
      cardBusinessType: this.state.cardBusinessType,
      cardState: this.state.cardState,
      cardCity: this.state.cardCity,
      cardClients: this.state.cardClients,
      cardClientsExclusions: this.state.cardClientsExclusions,
      cardClientsExceptions: this.state.cardClientsExceptions,
    };

    const handleAddBatch = (batch) => {
      if (this.state.value === 0) {
        // New Batch
        this.setState({
          respuesta: [...this.state.respuesta, batch],
        });
      } else if (this.state.value > 0) {
        // Update batch
        const newRespuesta = this.state.respuesta;
        newRespuesta[this.state.value - 1] = batch;
        this.setState({
          respuesta: newRespuesta,
        });
      }
    };

    const handleChange = (event, newValue) => {
      this.setState({
        value: newValue,
      });
      // this.emptyExclutions();
      if (newValue > 0) {
        this.executeExclutionRules(this.state.respuesta[newValue - 1]);
      } else this.executeExclutionRules(null);
    };

    return (
      <div className="products-admin">
        <div className="products-admin__top">
          <span className="products-admin__product-sku">
            {this.state.valueSku}
          </span>
          <span className="products-admin__product-name">
            {this.state.selectedProduct}
          </span>
          <div className="products-admin__switcher">
            <div
              className="products-admin__button-switch"
              onClick={this.toggleSwitch}
            >
              <div className={switchClass}></div>
            </div>
            <span className="products-admin__label-switch">{switchLabel}</span>
          </div>
          <div className="products-admin__combo-country">
            <Typography>
              {`Última modificación: ${
                this.state.hoursModificate
                  ? this.state.hoursModificate !== "" &&
                    this.state.selectedProduct !== " - "
                    ? this.state.hoursModificate
                    : ""
                  : ""
              }`}
            </Typography>
          </div>
          <Autocomplete
            id="input-search-products"
            // disabled={

            //   this.state.loadedCards < 1 ? true : false // TODO: las cards no siempre seran menores a 1
            // }
            options={this.state.products}
            onChange={this.handleAutocomplete}
            value={this.state.valueProduct}
            style={{ width: 580 }}
            getOptionLabel={(option) => {
              if (typeof option.sku !== "undefined")
                return (
                  (this.props.countriesCode === "mdcolombia"
                    ? option.sku.substr(13)
                    : option.sku.substr(11)) +
                  " - " +
                  option.description
                );
              else return "";
            }}
            renderOption={(option) => (
              <>
                {(this.props.countriesCode === "mdcolombia"
                  ? option.sku.substr(13)
                  : option.sku.substr(11)) +
                  ` - ` +
                  option.description}
              </>
            )}
            renderInput={(params) => (
              <div
                className="products-admin__search"
                ref={params.InputProps.ref}
              >
                <input
                  type="text"
                  className="products-admin__input-search"
                  placeholder="Buscar por producto, SKU..."
                  {...params.inputProps}
                ></input>
              </div>
            )}
          />
        </div>
        <div className={`products-admin__tabs`}>
          {" "}
          {/* //TODO name de los props */}
          <ul className="products-admin__tabs-list">
            {this.state.tabs.map((element) => (
              <li
                className={
                  `products-admin__content ` + this.getClassSelectedTab(element)
                }
              >
                <Paper square>
                  <Tabs
                    value={this.state.value}
                    onChange={handleChange}
                    variant="scrollable"
                    scrollButtons="auto"
                    aria-label="scrollable auto tabs"
                  >
                    <Tab label="+ NUEVO GRUPO" />
                    {this.state.respuesta && this.state.respuesta.length > 0 ? (
                      this.state.respuesta
                        .sort((a, b) => {
                          if (a.id < b.id) {
                            return -1;
                          }
                          if (a.id > b.id) {
                            return 1;
                          }
                          // a debe ser igual b
                          return 0;
                        })
                        .map((p, index) => (
                          <Tab
                            label={"Grupo " + (parseInt(index, 10) + 1)}
                            {...a11yProps(index)}
                          />
                        ))
                    ) : (
                      <></>
                    )}
                  </Tabs>
                  {this.state.stateTabsView === false ? (
                    <DashboardExclutions
                      ref="dashboardRef"
                      index={this.state.value}
                      idLote={
                        this.state.value > 0
                          ? this.state.respuesta[this.state.value - 1].id
                          : null
                      }
                      handleAddBatch={handleAddBatch}
                      selectedCountry={this.state.selectedCountryCode}
                      selectedProduct={this.state.valueProduct}
                      countriesCode={this.props.countriesCode}
                      cards={cards}
                      buttonUpdateDisabled={this.state.buttonUpdateDisabled}
                      emptyExclutions={this.emptyExclutions}
                      setSelectedCountry={this.setSelectedCountry}
                      selectedDateStart={this.state.selectedDateStart}
                      selectedDateEnd={this.state.selectedDateEnd}
                      setSelectedDateStart={this.setSelectedDateStart}
                      setSelectedDateEnd={this.setSelectedDateEnd}
                      filterCards={this.filterCards}
                      clearFilter={this.clearFilter}
                      clients={this.state.clients}
                      clientsException={this.state.clientsException}
                      setClientsException={this.onlySetClientsException}
                      clientsExclusions={this.state.clientsExclusions}
                      setClientsExclusions={this.onlySetCliets}
                      clasification={this.state.clasification}
                      dataRules={this.state.rules}
                      changeRules={this.state.changeRules}
                      selectedGroupData={this.state.selectedGroupData}
                      infinityClients={{
                        clientsExclusion: this.clientsExclusion,
                        clientsException: this.clientsException,
                      }}
                    />
                  ) : (
                    <DashboardSKULimits />
                  )}
                </Paper>
              </li>
            ))}
          </ul>
        </div>
        <Dialog onClose={this.handleDialogClose} open={this.state.dialogAlert}>
          <div className={`exclutions__alert-modal`}>
            <div className="exclutions__alert--label">
              ¿Salir sin guardar cambios?
            </div>
            <button
              className={"exclutions__button-loader black"}
              onClick={this.handleButtonCancelAlert}
            >
              Cancelar
            </button>
            <button
              className={"exclutions__button-loader black"}
              onClick={this.handleButtonAcceptAlert}
            >
              Aceptar
            </button>
          </div>
        </Dialog>

        <DialogLoaderHoneyLoad
          opened={this.state.dialogLoader.show}
          message={this.state.dialogLoader.message}
          handleClose={(e) => {
            console.log(
              "🚀 ~ file: DashboardProducts.js ~ line 260 ~ DashboardProducts ~ e",
              e
            );
          }}
        />
      </div>
    );
  }
}
